import { DEFAULT_LINE_THRESHOLD_COLOR } from 'app/routes/dashboard_.$dashboardId/dashboardWidgetConfigOptions'
import { isDefined, type DashboardWidget } from '@terros/common'
import { type ChartReferenceLineProps } from '@mantine/charts'

type DashboardLineWidget = Extract<DashboardWidget, { type: 'line' }>

export function toThresholdReferenceLines(widget: DashboardLineWidget): ChartReferenceLineProps[] | undefined {
  if (!isDefined(widget.threshold)) return undefined

  return [
    {
      y: widget.threshold,
      label: 'Threshold',
      color: widget.thresholdColor ?? DEFAULT_LINE_THRESHOLD_COLOR,
      strokeDasharray: '5 5',
      ifOverflow: 'extendDomain',
    },
  ]
}
